import { flowLabels } from "@/pages/newActuacion/stepsConfig";

const stepGuard = (to, from, next) => {
  // Validar parámetro 'type' en la query string si existe
  const typeParam = to.query.type;
  if (typeParam && !Object.keys(flowLabels).includes(typeParam)) {
    next("/not-found");
    return;
  }
  next();
};

export default stepGuard;
